import IcomoonSelection from '../../../../../static/fonts/icomoon/selection.json';

export const Icomoon = IcomoonSelection;
